module.exports = __webpack_public_path__ + "img/btn-tag.428734e8.png";